import { auth } from '@services/apis/auth';
import { trackPromise } from 'react-promise-tracker';

var requestAuthorizationLogin           = null;
var requestAuthorizationVerifyMfa       = null;
var requestAuthorizationRecoverPassword = null;
var requestAuthorizationRecoverPasswordConfirm = null;

export const AuthorizationLogin = async parametros => {
	if (requestAuthorizationLogin !== null || parametros !== undefined) {
		if (requestAuthorizationLogin !== null) requestAuthorizationLogin();
		if (parametros.cancelar) return 0;
	}

	var retorno = '';

	await trackPromise(
		auth
			.post(`/initiate`, {
				...parametros
			})
			.then(response => {
				retorno = response;
			})
			.catch(error => {
				retorno = error.response;
			})
	);

	return retorno;
};
export const AuthorizationDevLogin = async parametros => {
	if (requestAuthorizationLogin !== null || parametros !== undefined) {
		if (requestAuthorizationLogin !== null) requestAuthorizationLogin();
		if (parametros.cancelar) return 0;
	}

	var retorno = '';

	await trackPromise(
		auth
			.post(`/acessar`, {
				...parametros
			})
			.then(response => {
				retorno = response;
			})
			.catch(error => {
				retorno = error.response;
			})
	);

	return retorno;
};

export const AuthorizationVerifyMfa = async parametros => {
	if (requestAuthorizationVerifyMfa !== null || parametros !== undefined) {
		if (requestAuthorizationVerifyMfa !== null) requestAuthorizationVerifyMfa();
		if (parametros.cancelar) return 0;
	}

	var retorno = '';

	await trackPromise(
		auth
			.post(`/verify-mfa`, {
				...parametros
			})
			.then(response => {
				retorno = response;
			})
			.catch(error => {
				retorno = error.response;
			})
	);

	return retorno;
};

export const AuthorizationRecoverPassword = async parametros => {
	if (requestAuthorizationRecoverPassword !== null || parametros !== undefined) {
		if (requestAuthorizationRecoverPassword !== null) requestAuthorizationRecoverPassword();
		if (parametros.cancelar) return 0;
	}

	var retorno = '';

	await trackPromise(
		auth
			.post(`/recover-password`, {
				...parametros
			})
			.then(response => {
				retorno = response;
			})
			.catch(error => {
				retorno = error.response;
			})
	);

	return retorno;
};

export const AuthorizationRecoverPasswordConfirm = async parametros => {
	if (requestAuthorizationRecoverPasswordConfirm !== null || parametros !== undefined) {
		if (requestAuthorizationRecoverPasswordConfirm !== null) requestAuthorizationRecoverPasswordConfirm();
		if (parametros.cancelar) return 0;
	}

	var retorno = '';

	await trackPromise(
		auth
			.post(`/change-password`, {
				...parametros
			})
			.then(response => {
				retorno = response;
			})
			.catch(error => {
				retorno = error.response;
			})
	);

	return retorno;
};
